import { version } from '../../../../package.json';

/**
 * Versión visible (Santiago, 27/09): «Versión 3.0.0» en el acceso y en el pie del menú. Una sola fuente, `version` de
 * package.json; sube a mano según el tipo de subida (regla en docs/operacion/VERSIONES.md). El SHA sigue aparte: lo
 * escribe el despliegue en version.json.
 */
export const NUMERO_DE_VERSION: string = version;
